import React, { memo } from 'react';
import { Sector } from 'graphql-common';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from './SectorChip.module.scss';

export interface Props {
  disabled?: boolean;
  // Only the displayed fields are required, so callers can pass a full `Sector`
  // or a lightweight `{ name, color }` (e.g. built from a select option).
  sector?: Pick<Sector, 'name' | 'color'> | null;
  showIcon?: boolean;
  size?: ChipSizes;
  to?: string;
}

function SectorChip({
  disabled,
  sector,
  showIcon = true,
  size = ChipSizes.medium,
  to,
}: Props) {
  if (!sector) return null;
  const type = disabled
    ? ChipTypes.chipDisabled
    : colorToChipType(sector.color, ChipTypes.chipWhite);
  return (
    <Chip
      className={styles.root}
      label={sector.name}
      leftIcon={showIcon ? 'circle' : undefined}
      size={size}
      to={to}
      type={type}
    />
  );
}

export default memo(SectorChip);
